import {
  Gauge, Trophy, MessagesSquare, Users, Store, Award,
} from "lucide-react";

export const HOW_IT_WORKS_STEPS = [
  { n: "01", title: "Create your account", desc: "Join the grid — a quick approval keeps the community genuine and spam-free." },
  { n: "02", title: "Kit out your garage", desc: "List gear, log your setup, link iRacing/SimHub and personalise your profile." },
  { n: "03", title: "Race, trade & connect", desc: "Buy and sell safely, share laps, and talk shop with drivers worldwide." },
];

export const HOW_IT_WORKS_ROWS = [
  {
    icon: Gauge,
    title: "SimHub integration",
    desc: "Download the app and link SimHub like a dash with a couple of clicks. Your telemetry, races, lap times, and achievements automatically build your sim racing profile. Review your telemetry from your profile at any time on PC or on the app and compare to others to improve.",
    points: [
      "Recorded sessions & personal bests across 100+ sims",
      "Session detail views (lap times, splits, sector data)",
      "Finish-tracking with achievements linked to your profile",
      "Optional live telemetry on the mobile app when you're at your rig",
    ],
  },
  {
    icon: Trophy,
    title: "Achievements & Points",
    desc: "Your race finishes, lap times, achievements, marketplace sales and all your posts on the platform feed a shared points system. Climb the leaderboard and earn real rewards.",
    points: [
      "SimHub-driven finish achievements (podiums, wins, laps completed)",
      "Find and buy great deals on used gear or sell your own",
      "Points redeemable for rewards and upgrades from the Points Portal",
      "Ask questions, help answer others, post, and build your sim racing profile.",
    ],
  },
  {
    icon: MessagesSquare,
    title: "Forum",
    desc: "A sim racing focused forum built around a real data base of sim racing products. Threads carry equipment tags, organized by brand and product so you can easily find what you're looking for.",
    points: [
      "Category-organized discussions (general, setup questions, car setups, games/sims, and more).",
      "Equipment tagging via a real sim racing product catalog",
    ],
  },
  {
    icon: Users,
    title: "Sim Racing Network (social)",
    desc: "The paddock feed for laps, wins, builds and behind-the-scenes moments. Stories at the top, rich post cards below - like Instagram, tuned for sim racers.",
    points: [
      "Instagram-style stories from the community",
      "Categorized posts by achievements, laps, or rigs, so you can easily browse for ideas or inspiration.",
      "Likes, comments, saves, direct message a driver",
      "Follow other racers and follow their progress",
    ],
  },
  {
    icon: Store,
    title: "Marketplace with secure payments + shipping",
    desc: "List gear in minutes, or hire sim racing specialists for custom car setups, liveries, full rig builds and coaching. Easily browse listings by category and product. Buyer payments are held securely until delivery is confirmed, and we offer seamless shipping supplies + carrier discounts.",
    points: [
      "Secure checkout with payment held until delivery (Stripe)",
      "Hire specialists for setups, liveries, rig builds and coaching",
      "Standardized shipping boxes + supplies via SRC",
      "Discounted carrier rates and in-listing quote calculator",
      "Make Offer, Message Seller, local pickup or shipping",
    ],
  },
  {
    icon: Award,
    title: "Sponsorship Portal",
    desc: "Apply for sponsorship in a guided 4-step flow, without long forms or hours spent on proposals. Track your sponsorship and grow it with as your sim racing career grows.",
    points: [
      "Focused and guided 4-step application",
      "Sponsorship packages for every level from starting out to Pros.",
      "Direct messaging with the sponsorship team",
      "A sponsorship that grows with you: upload your growth and achievements to your sponsorship portal.",
      "Be eligible for selection for the SRC Academy: Sim to Real",
    ],
  },
];

export const HOW_IT_WORKS_FAQ = [
  {
    q: "Is Sim Racing Connected free to join?",
    a: "Absolutely, it's 100% free to join.",
  },
  {
    q: "How does buyer & seller protection work?",
    a: "Every marketplace purchase is held securely by Stripe. Nothing gets processed or shipped until the buyer pays. Funds are only released to the seller after the buyer confirms delivery. Disputes are handled by people who know sim gear.",
  },
  {
    q: "Do I have to ship with your carrier?",
    a: "Not at all. Sellers can offer local pickup or ship on their own. You can use our discounted carrier rates and pre-sized shipping boxes, or ship with your own carrier if you prefer.",
  },
  {
    q: "How does the SimHub integration work?",
    a: "Download the Sim Racing Connected App and pair it with SimHub on your simulator PC. All you have to do is scan the dash QR code on SimHub to pair the phone just like you would if it were a dash.",
  },
  {
    q: "Should I use the app or the website?",
    a: "Whichever you prefer! Your account and all content on the website and the app are in sync. You need the app to connect to the SimHub and you can buy, sell, post, shop, or use the SRC platform on your PC or your phone.",
  },
  {
    q: "How can I offer sim racing services on Sim Racing Connected?",
    a: "Simply create your account like any other user account. Once approved, list the services you offer and if you want to build a name or have an existing brand, set up your free storefront and custom URL.",
  },
  {
    q: "Are there any fees for offering sim building or car setups on the app?",
    a: "Transactions have a 3% fee just to cover Stripe fees, no different than if you were to accept payments outside using other services like PayPal but you get the benefits and reach of the SRC Platform.",
  },
];
